// extracted by mini-css-extract-plugin
export var closeButton = "_18-1";
export var container = "_18-0";
export var fullModalImage = "_18-2";